import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
} from 'motion-components';
import { FieldSelectApplogType } from '../fs-applog-type';
import { FieldSelectApplogGrouping } from '../fs-applog-grouping';
import { useTranslation } from 'react-i18next';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'logDate'),
      };
    }

    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [
          { originatedFrom: likeObj },
          { grouping: likeObj },
          { message: likeObj },
          { user: likeObj },
        ],
      };
    }
    if (values.logType) where = { ...where, logType: values.logType };
    // Ακριβές ταίριασμα grouping (π.χ. user-login)
    if (values.grouping) where = { ...where, grouping: values.grouping };
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  //console.log("filters-init ", initialValues);

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    searchText: initialValues?.searchText ?? '',
    logType: initialValues?.logType ?? null,
    grouping: initialValues?.grouping ?? null,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση (Message, User, Source, Grouping)')}
          type="search"
        />
        <FieldDateRanger
          as={FormCol}
          label={t('Ημερομηνία από:')}
          label2={t('έως:')}
          name="startDate"
          name2="endDate"
        />
        <FieldSelectApplogType />
        <FieldSelectApplogGrouping />
      </Row>
    </FormFilterCard>
  );
};
